var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit050(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14238_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 2.66714H4.53337C3.41327 2.66714 2.85322 2.66714 2.42539 2.88513C2.04907 3.07688 1.74311 3.38284 1.55136 3.75916C1.33337 4.18699 1.33337 4.74704 1.33337 5.86714V11.4671C1.33337 12.5872 1.33337 13.1473 1.55136 13.5751C1.74311 13.9514 2.04907 14.2574 2.42539 14.4492C2.85322 14.6671 3.41327 14.6671 4.53337 14.6671H10.1334C11.2535 14.6671 11.8135 14.6671 12.2414 14.4492C12.6177 14.2574 12.9236 13.9514 13.1154 13.5751C13.3334 13.1473 13.3334 12.5872 13.3334 11.4671V8.66714M5.33336 10.6671H6.44972C6.77584 10.6671 6.9389 10.6671 7.09235 10.6303C7.2284 10.5976 7.35846 10.5438 7.47775 10.4707C7.61231 10.3882 7.72761 10.2729 7.95821 10.0423L14.3334 3.66714C14.8857 3.11486 14.8857 2.21943 14.3334 1.66714C13.7811 1.11486 12.8857 1.11486 12.3334 1.66714L5.9582 8.04231C5.72759 8.27291 5.61229 8.38821 5.52984 8.52276C5.45673 8.64206 5.40286 8.77212 5.3702 8.90817C5.33336 9.06162 5.33336 9.22468 5.33336 9.5508V10.6671Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14238_54767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit050);
export default __webpack_public_path__ + "static/media/edit-050.eeb8dbe660bd7256fc95e122be7425e2.svg";
export { ForwardRef as ReactComponent };